import { render, staticRenderFns } from "./CreateAction.vue?vue&type=template&id=51006947"
import script from "./CreateAction.vue?vue&type=script&lang=js"
export * from "./CreateAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports